/* eslint-disable react/prop-types */
import { Box, Backdrop, CircularProgress } from "@mui/material";
import styled from "@emotion/styled";

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: "#fff",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: 0,
  left: 0,
  borderRadius: "12px",
}));

const StyledBox = styled(Box)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 2,
  position: "relative",
}));

export default function LoadingOverlay({ open }) {
  return (
    <StyledBackdrop open={open}>
      <CircularProgress color="secondary" />
    </StyledBackdrop>
  );
}
